import Header from "@/betby/components/Header";
import BetbyRenderer from "@/betby/components/BetbyRenderer";
import { NetworkRetryModal, TokenExpiredModal } from "@/betby/components/modal";
import { useBetbyPageViewModel } from "@/betby/viewmodels/useBetbyPageViewModel";
import type { CurrencyMode } from "@/betby/store/navStore";
import type { ThemeName } from "@/betby/theme";

export interface BetbyWidgetProps {
  /**
   * Host-authenticated session ticket used to bootstrap the Betby login flow.
   */
  sessionTicket: string;
  /**
   * Initial currency mode for the widget.
   */
  currencyMode?: CurrencyMode;
  /**
   * Hides the top navigation bar when set to true.
   */
  hideTopBar?: boolean;
  /**
   * Hides the page scrollbar when set to true.
   */
  hideScrollbar?: boolean;
  /**
   * Optional theme override. When omitted, iframe mode continues to read from URL query.
   */
  theme?: ThemeName;
  /**
   * BTRenderer SDK basename. Must match the host catch-all route prefix.
   */
  basename?: string;
}

type BetbyWidgetViewProps = {
  sessionTicket?: string;
  currencyMode?: CurrencyMode;
  hideTopBar?: boolean;
  hideScrollbar?: boolean;
  theme?: ThemeName;
  basename?: string;
};

export function BetbyWidget({
  basename = "/sportsbook",
  ...props
}: BetbyWidgetProps) {
  return <BetbyWidgetView {...props} basename={basename} />;
}

export function BetbyWidgetView({
  sessionTicket,
  currencyMode,
  hideTopBar,
  hideScrollbar,
  theme,
  basename,
}: BetbyWidgetViewProps) {
  const {
    isHydrated,
    hideTopBar: resolvedHideTopBar,
    hideScrollbar: resolvedHideScrollbar,
    handleBack,
    handleAddClick,
  } = useBetbyPageViewModel({
    sessionTicket,
    currencyMode,
    hideTopBar,
    hideScrollbar,
    theme,
  });

  if (!isHydrated) {
    return null;
  }

  return (
    <div
      className={`relative${resolvedHideScrollbar ? " scrollbar-hide h-screen overflow-y-auto" : ""}`}
    >
      <>
        {!resolvedHideTopBar && (
          <Header onBack={handleBack} onAddClick={handleAddClick} />
        )}
        <div className={resolvedHideTopBar ? "" : "mt-[50px]"}>
          <BetbyRenderer
            basename={basename}
            currencyMode={currencyMode}
            hideTopBar={hideTopBar}
          />
          {/* <TokenExpiredModal /> */}
          <NetworkRetryModal />
        </div>
      </>
    </div>
  );
}
